import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import hebrewTranslations from '@i18n/locales/he.json';
import englishTranslations from '@i18n/locales/en.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: englishTranslations,
      },
      he: {
        translation: hebrewTranslations,
      },
    },
    lng: 'he', // default language
    fallbackLng: 'he',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

